import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getAlumniStories, updateAlumniStories } from "./alumniStoriesApi";

interface AlumniStoriesState {
  loading: { get: boolean; save: boolean };
  req_success: { get: boolean; save: boolean };
  data: {
    zoom_url: string;
    alumni: AlumniItem[];
    hired_grads: HiredGradItem[];
  } | null;
}

export interface AlumniItem {
  name: string;
  subtext: string;
  description: string;
  tags: string;
  badge: string;
  icon: string;
}

export interface HiredGradItem {
  video_url: string;
  name: string;
  role: string;
  quote: string;
}

const initialState: AlumniStoriesState = {
  loading: { get: false, save: false },
  req_success: { get: false, save: false },
  data: null,
};

const alumniStoriesSlice = createSlice({
  name: "alumniStories",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAlumniStories.pending, (state) => {
        state.loading.get = true;
        state.req_success.get = false;
      })
      .addCase(getAlumniStories.fulfilled, (state, { payload }: PayloadAction<any>) => {
        state.loading.get = false;
        state.req_success.get = true;
        state.data = payload?.data ?? null;
      })
      .addCase(getAlumniStories.rejected, (state) => {
        state.loading.get = false;
      });

    builder
      .addCase(updateAlumniStories.pending, (state) => {
        state.loading.save = true;
        state.req_success.save = false;
      })
      .addCase(updateAlumniStories.fulfilled, (state, { payload }: PayloadAction<any>) => {
        state.loading.save = false;
        state.req_success.save = true;
        state.data = payload?.data ?? state.data;
      })
      .addCase(updateAlumniStories.rejected, (state) => {
        state.loading.save = false;
      });
  },
});

export default alumniStoriesSlice.reducer;
